import { render, staticRenderFns } from "./OperaIcon.vue?vue&type=template&id=1e025bb4&scoped=true"
import script from "./OperaIcon.vue?vue&type=script&lang=js"
export * from "./OperaIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e025bb4",
  null
  
)

export default component.exports